// Packages
import PropTypes from 'prop-types';

// Context
import { useUI } from 'context/UI';

// Components
import BTDProgress from '../BTDProgress';

// Other
import './styles.css';


const BTDButton = ({ className, colour, disabled, formButton, label, type, startIcon, style, onClick, size, target, url }) => {

	const { getLoading } = useUI();

	if(getLoading() && formButton) {

		return(

			<BTDProgress type='circular' />
		)
	}

	return (
		<>
		
		{url ?
				<a 
					href={url} 
					className={`BTDButton BTDButton--colour-${colour} BTDButton--size-${size} BTDButton--type-${type} ${disabled ? 'disabled' : ''} ${startIcon ? 'startIcon' : ''} ${className}`} 
					style={style}
					target={target}
				>
					{startIcon}
					{label}
				</a>
			:
		
			<button onClick={() => {

				if( ! disabled ) {

					if ( onClick )
					{
						onClick();
					}
				}

			}} style={style} className={`BTDButton BTDButton--colour-${colour} BTDButton--size-${size} BTDButton--type-${type} ${disabled ? 'disabled' : ''} ${startIcon ? 'startIcon' : ''} ${className}`}>
				{startIcon}
				{label}

			</button>
		}
		</>
	);

}

BTDButton.propTypes = {
	className: PropTypes.string,
	colour: PropTypes.string,
	disabled: PropTypes.bool,
	formButton: PropTypes.bool,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	size: PropTypes.string,
	startIcon: PropTypes.object,
	style: PropTypes.object,
	type: PropTypes.string,
	url: PropTypes.string,
}

BTDButton.defaultProps = {
	className: '',
	colour: 'default',
	disabled: false,
	formButton: false,
	label: '',
	onClick: () => {},
	size: '',
	startIcon: null,
	style: {},
	type: '',
	url: null
}


export default BTDButton;